/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectInstitutionAccount} from '../api'

export const useMutationSelectInstitutionAccount = createReactQueryMutationHook('selectInstitutionAccount', selectInstitutionAccount)
